unable to read source [project]/node_modules/encoding-sniffer/src/sniffer.ts